<template>
  <div class="container-fluid animate__animated animate__fadeIn animate__faster ">
    <div class="row">
      <div class="col-md-12 text-muted">
        <div class="float-end">
          <span>Last Updated: </span>
          <span>05/07/2026</span>
        </div>
      </div>
      <div class="col-12">
        <h1 class="text-center mt-2">EJ Welch Policies & Procedures</h1>
        <hr>
        <div class="row">
          <div
            class="col-md-12"
            ref="index">
            <button
              class="btn btn-primary back-to-top"
              @click="backToTop">
              <i class="fa fa-arrow-up"/>
            </button>
            <div
              class="card"
              style="box-shadow:2px 2px 5px lightgray;">
              <div class="card-body text-center">
                <h3>Index</h3>
                <hr>
                <div class="row">
                  <div class="col-md-4">
                    <a
                      href="javascript:void(0)"
                      @click="goto('hoursOfOperation')">
                      Hours of Operation
                    </a>
                  </div>
                  <div class="col-md-4">
                    <a
                      href="javascript:void(0)"
                      @click="goto('orderInformation')">
                      Order Information
                    </a>
                  </div>
                  <div class="col-md-4">
                    <a
                      href="javascript:void(0)"
                      @click="goto('willCall')">
                      Will Call / Pick Up Orders
                    </a>
                  </div>
                  <div class="col-md-4">
                    <a
                      href="javascript:void(0)"
                      @click="goto('phoneOrders')">
                      Phone Orders
                    </a>
                  </div>
                  <div class="col-md-4">
                    <a
                      href="javascript:void(0)"
                      @click="goto('onlineOrders')">
                      Online Orders
                    </a>
                  </div>
                  <div class="col-md-4">
                    <a
                      href="javascript:void(0)"
                      @click="goto('companyTruck')">
                      Company Truck Delivery
                    </a>
                  </div>
                  <div class="col-md-4">
                    <a
                      href="javascript:void(0)"
                      @click="goto('freight')">
                      Freight Policy
                    </a>
                  </div>
                  <div class="col-md-4">
                    <a
                      href="javascript:void(0)"
                      @click="goto('damages')">
                      Damages / Shortages
                    </a>
                  </div>
                  <div class="col-md-4">
                    <a
                      href="javascript:void(0)"
                      @click="goto('pricing')">
                      Pricing / Additional Charges
                    </a>
                  </div>
                  <div class="col-md-4">
                    <a
                      href="javascript:void(0)"
                      @click="goto('specialOrders')">
                      Special Orders
                    </a>
                  </div>
                  <div class="col-md-4">
                    <a
                      href="javascript:void(0)"
                      @click="goto('cutOff')">
                      Order Cut off Times
                    </a>
                  </div>
                  <div class="col-md-4">
                    <a
                      href="javascript:void(0)"
                      @click="goto('sds')">
                      Safety Data Sheets (SDS)
                    </a>
                  </div>
                  <div class="col-md-4">
                    <a
                      href="javascript:void(0)"
                      @click="goto('warranty')">
                      Warranty
                    </a>
                  </div>
                  <div class="col-md-4">
                    <a
                      href="javascript:void(0)"
                      @click="goto('payment')">
                      Payment Terms
                    </a>
                  </div>
                  <div class="col-md-4">
                    <a
                      href="javascript:void(0)"
                      @click="goto('holidays')">
                      Holiday Schedule
                    </a>
                  </div>
                  <div class="col-md-4">
                    <a
                      href="javascript:void(0)"
                      @click="goto('delivery')">
                      Carrier Deliveries and Claims
                    </a>
                  </div>
                  <div class="col-md-4">
                    <a
                      href="javascript:void(0)"
                      @click="goto('shipment')">
                      Shipment Receipt
                    </a>
                  </div>
                  <div class="col-md-4">
                    <a
                      href="javascript:void(0)"
                      @click="goto('returns')">
                      Returns
                    </a>
                  </div>
                  <div class="col-md-4">
                    <a
                      href="javascript:void(0)"
                      @click="goto('willCallPickup')">
                      Will Call Orders Ready for Pickup
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <!-- Hours of operation -->
            <div
              class="mt-3"
              id="hoursOfOperation">
              <h3>Hours of Operation</h3>
              <span>Our hours of operation are Monday - Friday 7:00am to 4:00pm CST</span>
              <!-- <a
                class="mx-1"
                href="mailto:'customerservice@ejwelch.com'">
                Contact Customer Service
              </a>
              <span class="me-1">at</span>
              <a href="tel:888-396-1280">888-396-1280</a> -->
            </div>
            <!-- Order Information -->
            <div
              class="mt-3"
              id="orderInformation">
              <h3>Order Information</h3>
              E. J. Welch is dedicated to delivering dependable service with consistent, reliable delivery times. Orders scheduled for delivery on company trucks must be placed by noon on the business day prior to the assigned delivery date. Orders shipped via UPS or LTL will ship the next business day, subject to product availability. Direct-to-customer shipping is available upon request, with applicable freight charges.
            </div>
            <!-- Will Call / Pick Up Orders -->
            <div
              class="mt-3"
              id="willCall">
              <h3>Will Call / Pick Up Orders</h3>
              Orders may be picked up at your local branch. To ensure timely service, customers are encouraged to call ahead so orders can be prepared in advance.
            </div>
            <!-- Phone Orders -->
            <div
              class="mt-3"
              id="phoneOrders">
              <h3>Phone Orders</h3>
              Orders submitted by phone or through an Account Manager will receive an email order acknowledgment.
            </div>
            <!-- Online Orders -->
            <div
              class="mt-3"
              id="onlineOrders">
              <h3>Online Orders</h3>
              Orders placed online will receive confirmation reflecting product availability. Deliveries will follow the customer's regularly scheduled delivery day. Please include special instructions at the time of order submission.
            </div>
            <!-- Company Truck Delivery -->
            <div
              class="mt-3"
              id="companyTruck">
              <h3>Company Truck Delivery (where available)</h3>
              Deliveries require a minimum order of $500 and are made on the customer's regularly scheduled delivery day. Please check with your local branch for your assigned day. A $75 delivery fee applies to qualifying orders. Delivery service is available within a 90&#8209;mile radius of the local branch.
            </div>
            <!-- Freight Policy -->
            <div
              class="mt-3"
              id="freight">
              <h3>Freight Policy – 3rd Party Carrier - LTL</h3>
              <ul>
                <li>All in-stock orders will be scheduled with carriers for earliest possible pick up from your local branch</li>
                <li>Order transit times vary</li>
                <li>3rd Party carrier delivery orders are subject to the full freight amount charged by the carrier</li>
                <li>Special orders or circumstances may increase standard delivery fee amount (i.e., requires liftgate, residential, delivery appointments required)</li>
                <li>Additional charges may apply to oversized goods</li>
                <li>Certain heavy machinery may not count towards the pre-paid minimum for orders and may even incur all freight charges when shipped individually. Shipments to any other address other than what is listed on the account may incur additional fees.</li>
                <li>Direct shipments from vendors can only ship to addresses listed on the account.</li>
                <li>All freight charges incurred from direct shipments from vendors will be added to the invoice. This includes, but is not limited to detention charges, changes in address fees, improper lift gate requirements, etc.</li>
                <li>All job site deliveries have a minimum fee of $200 applied to the order.</li>
              </ul>
              Please
              <a
                class="mx-1"
                href="mailto:'customerservice@ejwelch.com'">
                Contact Customer Service
              </a>for additional information regarding our Freight Policy.
            </div>
            <!-- Damages / Shortages -->
            <div
              class="mt-3"
              id="damages">
              <h3>Damages / Shortages</h3>
              Customers must inspect all orders against the packing slip upon receipt. Any discrepancies or visible damage must be clearly noted on the delivery receipt at the time of delivery. Freight claims for prepaid freight orders may be submitted by contacting EJ Welch Customer Service or by emailing&nbsp;
              <a href="mailto:freightclaims@ejwelch.com">freightclaims@ejwelch.com</a>.
              For freight collect orders, the customer is responsible for filing claims directly with the carrier. Photographs of all damages are required and should be submitted immediately. Claims cannot be filed if the damage or discrepancy is not documented on the bill of lading at the time of delivery.
            </div>
            <!-- Pricing -->
            <div
              class="mt-3"
              id="pricing">
              <h3>Pricing / Additional Charges</h3>
              E. J. Welch is committed to providing competitive and consistent pricing. From time to time, market conditions may necessitate immediate price adjustments. Customers are encouraged to contact their Account Manager with any questions regarding current or upcoming pricing changes. While certain cost increases are unavoidable, we remain committed to managing expenses responsibly and appreciate your partnership.
            </div>
            <!-- Special Orders -->
            <div
              class="mt-3"
              id="specialOrders">
              <h3>Special Orders</h3>
              While E. J. Welch stocks a broad range of inventory, certain items may require special ordering. In these cases, E.J. Welch will place a special order upon request. An Order Acknowledgement will be emailed for customer review and must be signed and returned to Customer Service prior to order placement. Freight charges will apply to special orders shipped directly to the customer. All special-order items are non&#8209;returnable. For assistance or questions regarding special orders, please contact your Account Manager or Customer Service Department.
            </div>
            <!-- Order Cut Off Times -->
            <div
              class="mt-3"
              id="cutOff">
              <h3>Order Cut-Off Time Policy</h3>
              E. J. Welch 	Times are based on DC locations Central Time Zones
              <table class="table table-sm table-striped">
                <thead>
                  <tr>
                    <th>DC</th>
                    <th>LTL Cut off</th>
                    <th>UPS Cut off</th>
                    <th>Store Hours</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>S27E - Elk Grove</td>
                    <td>11:00 AM</td>
                    <td>11:00 AM</td>
                    <td>7:00 - 4:00</td>
                  </tr>
                  <tr>
                    <td>S60 - Houston</td>
                    <td>11:00 AM</td>
                    <td>11:00 AM</td>
                    <td>7:30 - 4:30</td>
                  </tr>
                </tbody>
              </table>
              All orders received after the cutoff will be processed the next business day.
            </div>
            <!-- SDS Sheets -->
            <div
              class="mt-3"
              id="sds">
              <h3>Safety Data Sheets (SDS)</h3>
              E. J. Welch has access to material safety data sheets during normal business hours. Contact your account manager, local branch, or CS department for additional information.
            </div>
            <!-- Warranty -->
            <div
              class="mt-3"
              id="warranty">
              <h3>Warranty</h3>
              E. J. Welch recognizes only the applicable manufacturer's warranty, which is provided in lieu of all other express or implied warranties, including warranties of merchantability or fitness for a particular purpose. E. J. Welch disclaims any additional representations, obligations, or liabilities, including indirect, incidental, punitive, or consequential damages. This limitation of warranty and liability supersedes all prior representations or warranties of any kind.
            </div>
            <!-- Payment Terms -->
            <div
              class="mt-3"
              id="payment">
              <h3>Payment Terms</h3>
              E. J. Welch operates with terms of Net 30 Days (Terms are only approved for customers who have established an account with EJW) as well as with standard cash in advance methods.  There will be a 1.5% monthly service charge on past-due balances. Please assist yourself and us by avoiding these additional charges.
            </div>
            <!-- Holidays -->
            <div
              class="mt-3"
              id="holidays">
              <h3>Holiday Schedule</h3>
              E. J. Welch observes the following as company holidays and is closed for business on the following days:
              <ul>
                <li>New Year's Day</li>
                <li>Memorial Day</li>
                <li>Independence Day</li>
                <li>Labor Day</li>
                <li>Thanksgiving Day</li>
                <li>Friday after Thanksgiving</li>
                <li>Christmas Eve</li>
                <li>Christmas Day</li>
              </ul>
              Should any of these days fall on a weekend, we will observe either the Friday before or the Monday after.
            </div>
            <!-- Carrier Deliveries and Claims -->
            <div
              class="mt-3"
              id="delivery">
              <h3>Carrier Deliveries and Claims</h3>
              Customers must inspect all shipments prior to signing the packing slip or bill of lading. Any shortages, damages, or discrepancies must be clearly noted on the carrier's delivery documentation or electronic device at the time of receipt. Customers must notify their local branch or Customer Service within 24 hours of delivery to report any issues. For freight collect orders arranged by the customer, the customer is responsible for filing claims directly with the carrier. Freight claims will not be accepted if the shipment is signed "free and clear" or if issues are not reported within the required timeframe. Photographs and supporting documentation may be required to facilitate claim processing. Failure to follow these procedures may limit E. J. Welch's ability to pursue recovery with the freight carrier.
            </div>
            <!-- Shipment Receipt -->
            <div
              class="mt-3"
              id="shipment">
              <h3>Shipment Receipt-CHECKLIST</h3>
              <p>
                Every pallet that leaves our Distribution Centers will have our&nbsp;
                <strong>
                  <u>green plastic pallet cap</u>
                </strong>
                &nbsp;on the top of pallet&nbsp;
                <strong>
                  <u>AND</u>
                </strong>
                &nbsp;the&nbsp;
                <strong>
                  <u>red and white security tape across the top of the pallet.</u>
                </strong>
              </p>
              <p>
                If either of these are missing, please do a thorough inspection of your shipment.&nbsp;
                <strong>
                  <u>MAKE NOTE OF THAT ON YOUR DELIVERY RECEIPT OR CARRIER TOUCH FREE DEVICE.</u>
                </strong>
              </p>
              <p>
                Example: <strong>Green wrap and/or Security tape missing.</strong>
              </p>
              <p>
                Any&nbsp;
                <strong>
                  <u>VISUAL DAMAGE</u>
                </strong>
                &nbsp;or&nbsp;
                <strong>
                  <u>IRREGULARITIES</u>
                </strong>
                &nbsp;must be noted on delivery receipt or carrier's electronic device. Please inspect&nbsp;
                <strong>
                  <u>Entire Shipment.</u>
                </strong>
                &nbsp;If damage is found before signing BOL.
              </p>
              <p>
                <strong>
                  <u>EVERY</u> pallet EJ WELCH ships you should look like below when you receive it:
                </strong>
              </p>
              <div class="row">
                <div class="col-md-12 text-center">
                  <img
                    :src="wrappedOrder"
                    class="img-fluid">
                </div>
              </div>
              <p>
                It is the&nbsp;
                <strong>
                  <u>customer's responsibility</u>
                </strong>
                &nbsp;to verify information supplied on the delivery receipt or carrier device as it relates to pallet count and/or any loose items before releasing the driver.&nbsp;
                <strong>
                  <u>Any damage must be notated, and documentation provided such as pictures.</u>
                </strong>
              </p>
              <p>
                You must&nbsp;
                <strong>CALL</strong>
                &nbsp;Customer Service&nbsp;
                <strong>
                  WITHIN
                  <u>24 HOURS</u>
                </strong>
                &nbsp;if you realize any shortages or damages on your order at (888) 396-1280 (don't wait for your rep to handle).
              </p>
              <p>
                <div class="text-muted">
                  * Customer compliance with the above noted steps will allow us to assist you in the event you experience damage and or shortages.
                </div>
                <div class="mt-3">
                  <strong>
                    <u>If these steps are not followed, we have LITTLE to NO recourse with the Freight Carrier.</u>
                  </strong>
                </div>
              </p>
            </div>
            <!-- Returns -->
            <div
              class="mt-3"
              id="returns">
              <h3>Return Policy and Cancellation Policy</h3>
              Request for credits or returns can be made by one of the following:
              <ul>
                <li>Phone</li>
                <li>Email</li>
                <li>In-person</li>
              </ul>
              The following details must be provided to the Customer or Account Manager when requesting credit or return:
              <ul>
                <li>Original Invoice or Sales Order#</li>
                <li>Reason for credit request</li>
              </ul>
              The following conditions must be met before a credit or return can be processed:
              <ul>
                <li>The item was ordered from E. J. Welch (EJW)</li>
                <li>Orders eligible for return within 30 days of the original sale</li>
                <li>Item must be in resaleable condition: original packaging, no stickers, no damage, or writing on the item or packaging</li>
                <li>Please provide pictures of items requesting to be returned</li>
                <li>All vendor merchandise considered defective is subject to inspection and approval by the branch</li>
              </ul>
              <strong>Merchandise Return:</strong>
              <ul>
                <li>For problems with an order (shortages, damage, wrong items, etc.) the customer must
                  <a
                    class="mx-1"
                    href="mailto:'customerservice@ejwelch.com'">
                    Contact Customer Service
                  </a>
                  or their Account Manager (AM) within 24 hours.</li>
                <li>EJW will accept returns of stocked merchandise only, within 30 days of purchase.</li>
                <li>A return authorization must be created prior to returning product.</li>
                <li>Special orders, close-out specials, discontinued items, and "All Sales Final" sales are all non-returnable.</li>
                <li>Returns without authorization will not be accepted.</li>
                <li>During the winter months adhesives, primers or other products affected by freezing temperatures are non-returnable.</li>
                <li>Returned items may be subject to a 25% restocking fee (see below).</li>
              </ul>
              <strong>Scheduling Returns:</strong>
              <ul>
                <li>Once a return has been reviewed by Customer Service or the Branch Manager, a determination will be made regarding whether the material will be returned by the customer or picked up by EJW. Upon successful inspection of the material, the applicable credit will be issued to the customer's account.</li>
              </ul>
              <strong>Order Entry Errors:</strong>
              <ul>
                <li>If a return results from an EJW error, Customer Service will authorize the return to the branch and coordinate either customer drop-off or EJW pickup. No restocking fee will apply.</li>
              </ul>
              <strong>Restocking Fee:</strong>
              <ul>
                <li>Returned stock items may be subject to a 25% restocking fee. Nonstock items require vendor approval prior to the issuance of any credit. Any applicable restocking fees and return freight charges to the vendor will be deducted from the customer's credit.</li>
              </ul>
              <strong>Order Cancellation:</strong>
              <ul>
                <li>Order cancellations for stocked items will be accepted within 30 days of the original order date. Cancellations of special-order items are subject to supplier policies. To request a cancellation, customers should contact their Customer Service Manager, Account Manager, or local Branch Team.</li>
              </ul>
            </div>
            <!-- Will Call Orders Ready for Pickup -->
            <div
              class="mt-3"
              id="willCallPickup">
              <h3>Will Call Orders Ready for Pickup</h3>
              EJ Welch will notify customers when their order is ready for pickup at the branch. Orders will be held for up to 30 business days unless otherwise agreed to in writing. Prior to the expiration of this hold period, EJ Welch will contact the customer by phone or email to provide a pickup reminder and review available pickup or shipping options. EJ Welch recognizes that job site delays, natural disasters, and other force majeure events may occur and will make reasonable efforts to support affected customers when possible. Customers experiencing such circumstances are encouraged to contact their Customer Service team promptly so appropriate arrangements can be considered.
            </div>
            <!-- Contact -->
            <div class="mt-3">
              <h3>Who to Contact</h3>
              <table class="table table-sm table-striped">
                <thead>
                  <tr>
                    <th>Issue</th>
                    <th>Contact</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Order Errors</td>
                    <td>Customer Service</td>
                  </tr>
                  <tr>
                    <td>Damages / Shortages</td>
                    <td>Customer Service</td>
                  </tr>
                  <tr>
                    <td>Check the status of a pending order</td>
                    <td>Customer Service</td>
                  </tr>
                  <tr>
                    <td>Pricing Discrepancies</td>
                    <td>Account Manager</td>
                  </tr>
                  <tr>
                    <td>Defectives</td>
                    <td>Account Manager/Customer Service</td>
                  </tr>
                  <tr>
                    <td>Samples</td>
                    <td>Account Manager/Customer Service</td>
                  </tr>
                  <tr>
                    <td>Other Issues</td>
                    <td>Account Manager</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data(){
      return{
        wrappedOrder: require('../../../../../assets/images/ejw/WrappedOrder.jpg')
      }
    },
    methods:{
      goto(id){
        const base = document.getElementById('content')
        const el = document.getElementById(id)
        base.scrollTo({left: 0, top: el.getBoundingClientRect().top - 120, behavior: 'smooth'})
      },
      backToTop(){
        const base = document.getElementById('content')
        base.scrollTo({left: 0, top: 0, behavior: 'smooth'})
      }
    }
  }
</script>

<style scoped>
 .back-to-top{
    position: fixed;
    z-index: 1;
    bottom: .5rem;
    right: 2rem;
    opacity: 0.5;
  }
  @media(max-width: 991px){
    .back-to-top{
      position: fixed;
      z-index: 1;
      bottom: 5rem;
      right: 2rem;
      opacity: 0.5;
    }
  }
</style>
